import { Module } from 'vuex'
import { getters } from '@/store/modules/spinner/spinnerGetters'
import { actions } from '@/store/modules/spinner/spinnerActions'
import { mutations } from '@/store/modules/spinner/spinnerMutations'
import { SpinnerState } from '@/store/modules/spinner/spinnerTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const state: SpinnerState = {
  spinner: {
    message: false,
    show: false
  },
  showSpinnerLayer: false
}

const namespaced: boolean = true

export const spinnerModule: Module<SpinnerState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
